import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './theme/ThemeContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import HomePage from './pages/HomePage';
import MyHikesPage from './pages/MyHikesPage';
import HikeDetailPage from './pages/HikeDetailPage';
import CreateHikePage from './pages/CreateHikePage';
import AdminDashboard from './pages/admin/AdminDashboard';
import ArchivedHikesPage from './pages/ArchivedHikesPage';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmailPrompt from './pages/VerifyEmailPrompt';
import VerifyEmailPage from './pages/VerifyEmailPage';
import VerifyEmailChangePage from './pages/VerifyEmailChangePage';
import MyAccountPage from './pages/MyAccountPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GuestRegistrationPage from './pages/GuestRegistrationPage';
import GuestUnregisterPage from './pages/GuestUnregisterPage';
import Spinner from './components/Spinner';
import colors from './theme/colors';
import { EmbedPage, EmbedHikePageWrapper } from './embed';

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <AppContent />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [showRegister, setShowRegister] = useState(false);

  // Reset to login view when navigating to /login from elsewhere
  useEffect(() => {
    if (location.pathname === '/login') {
      setShowRegister(false);
    }
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Spinner size="lg" color="blue" />
          <div className="text-xl" style={{ color: colors.primary.DEFAULT }}>Caricamento...</div>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Embed routes - no navbar, no auth context dependency */}
      <Route path="/embed/hike" element={<EmbedPage />} />
      <Route path="/embed/hike-page" element={<EmbedHikePageWrapper />} />

      <Route path="/login" element={
        user ? <Navigate to="/" /> : (
          showRegister ? (
            <Register onSwitchToLogin={() => setShowRegister(false)} />
          ) : (
            <Login onSwitchToRegister={() => setShowRegister(true)} />
          )
        )
      } />

      <Route path="/verify-email-prompt" element={<VerifyEmailPrompt />} />
      <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
       <Route path="/verify-email-change/:token" element={<VerifyEmailChangePage />} />
       <Route path="/forgot-password" element={user ? <Navigate to="/" /> : <ForgotPassword />} />
       <Route path="/reset-password/:token" element={user ? <Navigate to="/" /> : <ResetPassword />} />

      <Route path="/*" element={
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/my-hikes" element={
              <ProtectedRoute>
                <MyHikesPage />
              </ProtectedRoute>
            } />
            <Route path="/my-account" element={
              <ProtectedRoute>
                <MyAccountPage />
              </ProtectedRoute>
            } />
            <Route path="/hike/:id" element={<HikeDetailPage />} />
              <Route path="/guest-register/:id" element={<GuestRegistrationPage />} />
              <Route path="/hikes/:id/guest-unregister" element={<GuestUnregisterPage />} />
            <Route path="/create-hike" element={
              <ProtectedRoute>
                <CreateHikePage />
              </ProtectedRoute>
            } />
            <Route path="/edit-hike/:id" element={
              <ProtectedRoute>
                <CreateHikePage />
              </ProtectedRoute>
            } />
            <Route path="/archived-hikes" element={
              <ProtectedRoute>
                <ArchivedHikesPage />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } />
          </Routes>
        </div>
      } />
    </Routes>
  );
}